<template>
  <CouponHome v-if="$globalModel.state.isCouponMall" />
  <DuoduoHome v-else :page-hd-height="pageHeaderHeight" />
</template>

<script>
  import CouponHome from './components/coupon_home'
  import DuoduoHome from './components/duoduo_home_2024/index.vue'
  import Vue from 'vue'
  import { dcb } from '@dcb/jssdk'
  import { devOrProd, Track } from '@/utils'
  import { globalModel } from '@/model'

  export default Vue.extend({
    components: {
      // 多多商城（省内版商城）首页
      DuoduoHome,
      // 消费券商城首页
      CouponHome,
    },

    mixins: [
      Track.provideMark(() => ({
        page: '首页',
      })),
    ],

    beforeRouteEnter(to, from, next) {
      if (globalModel.state.isChinaMall) {
        dcb.navigateTo({
          url: devOrProd(
            'https://h5p-gw.duotest.cn/dcb-mall-nationwide/#/index?isFull=true&isAuth=true&isLogin=true',
            'https://h5p-gw.gogpay.cn/dcb-mall-nationwide/#/index?isFull=true&isAuth=true&isLogin=true',
          ),
        })
      } else {
        next()
      }
    },

    activated() {
      this.$track.push({
        name: '浏览多多商城首页',
        id: 'LiuLanShangChengSouYe',
        extra: {},
      })
    },
  })
</script>
